// Decentní odznak v liště signalizující probíhající donačítání agend z Magicu.
// Po dokončení ho rodič skryje (loading=false). Při chybě (error=true) zobrazí červenou chybu
// místo spinneru (pojistka proti zacyklení načítání plochy Magicu).

import { useTranslation } from 'react-i18next';

import type { MenuLoadViz } from './menuTypes';
import { MenuDots, MenuSpinner } from './LoadIndicator';

export interface GlobalLoadBadgeProps {
  readonly loading: boolean;
  readonly viz?: MenuLoadViz;
  /** Načítání plochy Magicu selhalo → místo spinneru červená chyba (má přednost před loading). */
  readonly error?: boolean;
}

export function GlobalLoadBadge({ loading, viz = 'spinner', error = false }: GlobalLoadBadgeProps) {
  const { t } = useTranslation('sharedUi');

  if (error) {
    return (
      <span
        role="alert"
        title={t('mainMenu.globalLoadErrorHint')}
        className="border-phx-danger text-phx-danger rounded-phx inline-flex h-5 items-center gap-1.5 border px-2 text-[10.5px] font-medium"
      >
        <span aria-hidden>⚠</span>
        <span className="font-mono tracking-[-0.01em]">{t('mainMenu.globalLoadError')}</span>
      </span>
    );
  }

  if (!loading) return null;
  return (
    <span className="bg-phx-primary-tint text-phx-primary-active rounded-phx inline-flex h-5 items-center gap-1.5 px-2 text-[10.5px] font-medium">
      {viz === 'dots' ? <MenuDots /> : <MenuSpinner />}
      <span className="font-mono tracking-[-0.01em]">{t('mainMenu.globalLoad')}</span>
    </span>
  );
}
